import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";

const accountApplicationForm = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const tfa2919 = queryParams.get("tfa_2919") ? queryParams.get("tfa_2919"): "";
    const tfa3957 = queryParams.get("tfa_3957") ?queryParams.get("tfa_3957"): "";
    const tfa3961 = queryParams.get("tfa_3961") ?queryParams.get("tfa_3961"): "";
    return (
            <div className="wrapper">
                <Helmet>
                    {
                        store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {

                            return row.rowTitle === "Ship" ? row.sections.map((section) => {
                                return section.title === "Apply" ? <meta name="description" content={section.content['seo-description']}/> : null
                            }) : null


                        }) : null
                    }
                </Helmet>
                <Breadcrumbs/>
                <h1 className="two-three-rows__title">Account Application Form</h1>
                <div className="iframe-box-wrapper">
                    <FormAssembly formReferenceName="ACCOUNT_APPLICATION_FORM"
                                  tfa2919 = {tfa2919}
                                  tfa3957 = {tfa3957}
                                  tfa3961 = {tfa3961}
                    />

                </div>
            </div>
    );
};

export default accountApplicationForm;



// WEBPACK FOOTER //
// ./src/pages/ship/StartShipping/AccountApplicationForm.js